import Vue from "vue";

// ???: dynamically import App (otherwise, sync-engine mixins get imported before DB is registered)
var App = () => import("./App");
// import App from "./App";

import router from "./router/router";
import store from "./store/store";
import mixins from "./mixins/mixins";
import mixinsMeeting from "./mixins/mixins-meeting";
import mixinsVotes from "./mixins/mixins-votes";

import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

import axios from "axios";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import "./font-awesome/font-awesome.js";
import i18n from "./translations/i18n";
import vSelect from "vue-select";
import Multiselect from "vue-multiselect";
import underscore from "vue-underscore";
import PrettyCheckbox from "pretty-checkbox-vue";
import VueFileAgent from "vue-file-agent";
import "vue-file-agent/dist/vue-file-agent.css";
import { SlickList, SlickItem } from "vue-slicksort";
import Loader from "@/components/Loader";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import LoaderOverlay from "@/components/LoaderOverlay";
import VueCrontab from "vue-crontab";
// import VueHtml2pdfWrapper from "@/components/VueHtml2pdfWrapper";

// NOTE: vue-moment
const vueMoment = require("vue-moment");
const moment = require("moment-timezone");
Vue.use(vueMoment, {
  moment,
});

// NOTE: Vee Validate
import { ValidationObserver, ValidationProvider, extend, configure } from "vee-validate";
import en from "vee-validate/dist/locale/en.json";
import fr from "vee-validate/dist/locale/fr.json";
import * as rules from "vee-validate/dist/rules";
Object.keys(rules).forEach(rule => {
  if (i18n.locale === "fr") {
    extend(rule, {
      ...rules[rule], // add the rule
      message: fr.messages[rule], // add its message
    });
  } else if (i18n.locale === "en") {
    extend(rule, {
      ...rules[rule], // add the rule
      message: en.messages[rule], // add its message
    });
  }
});
configure({
  classes: {
    // valid: "is-valid",
    // invalid: "is-invalid",
    // dirty: ["is-dirty", "is-dirty"], // multiple classes per flag!
    // ...
  },
});

Vue.use(VueFileAgent);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueSweetalert2);
Vue.use(underscore);
Vue.use(PrettyCheckbox);
Vue.use(VueCrontab);

Vue.component("appLoader", Loader);
Vue.component("appLoaderOverlay", LoaderOverlay);
Vue.component("vfa-sortable-list", SlickList);
Vue.component("vfa-sortable-item", SlickItem);
Vue.component("v-select", vSelect);
Vue.component("v-multiselect", Multiselect);
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
// Vue.component("VueHtml2pdfWrapper", VueHtml2pdfWrapper);

// FIXME: needs work.. (desktop app)
if (!process.env.VUE_APP_IS_WEB) {
  const electron = require("electron");
  const path = require("path");
  Vue.use(require("vue-electron"));

  // get the database path from package.json (this is used only for desktop app)
  process.env.DATABASE = require("../../package.json").database;

  const fs = require("fs");

  // Create media directory in production
  if (
    !fs.existsSync(electron.remote.app.getPath("userData") + "/media") &&
    process.env.NODE_ENV == "production"
  ) {
    try {
      // create media directory in /home/user/snap/agv-app/x1/.config/agv-app ..
      fs.mkdirSync(path.join(electron.remote.app.getPath("userData"), "media"));
    } catch (err) {
      console.error(err);
    }
  }

  // Create the database file in production
  if (
    !fs.existsSync(electron.remote.app.getPath("userData") + "/" + process.env.DATABASE) &&
    process.env.NODE_ENV == "production"
  ) {
    try {
      // Get the database from:
      // /snap/agv-app/x1/resources/app.asar/dist/electron/../database/agv.sqlite3
      // and copy it to:
      // /home/user/snap/agv-app/x1/.config/agv-app/agv.sqlite3
      fs.copyFileSync(
        path.join(__dirname, "../database/", process.env.DATABASE),
        path.join(electron.remote.app.getPath("userData"), process.env.DATABASE)
      );
      // TRYING TO COPY THE ENTIRE FOLDER
      // fs.copy(
      //   __dirname,
      //   "../documents/",
      //   electron.remote.app.getPath("userData") + "/documents",
      //   function (err) {
      //     if (err) {
      //       console.error(err);
      //     } else {
      //       console.log("success!");
      //     }
      //   }
      // ); // copies directory, even if it has subdirectories or files
    } catch (err) {
      console.error(err);
    }
  }

  // Load models...
  var db = {};
  db["Agency"] = require("./database/models/Agency.js");
  db["Building"] = require("./database/models/Building.js");
  db["BuildingLot"] = require("./database/models/BuildingLot.js");
  db["BuildingOwner"] = require("./database/models/BuildingOwner.js");
  db["BuildingOwnerBuildingLot"] = require("./database/models/BuildingOwnerBuildingLot.js");
  db["BuildingOwnerVotingRight"] = require("./database/models/BuildingOwnerVotingRight.js");
  db["Contact"] = require("./database/models/Contact.js");
  db["GeneralSetting"] = require("./database/models/GeneralSetting.js");
  db["Invoice"] = require("./database/models/Invoice.js");
  db["Licence"] = require("./database/models/Licence.js");
  db["LicenceLimit"] = require("./database/models/LicenceLimit.js");
  db["Majority"] = require("./database/models/Majority.js");
  db["Mandate"] = require("./database/models/Mandate.js");
  db["Media"] = require("./database/models/Media.js");
  db["Meeting"] = require("./database/models/Meeting.js");
  db["MeetingResolution"] = require("./database/models/MeetingResolution.js");
  db["Payment"] = require("./database/models/Payment.js");
  db["Resolution"] = require("./database/models/Resolution.js");
  db["ResolutionCatalog"] = require("./database/models/ResolutionCatalog.js");
  db["ResolutionVote"] = require("./database/models/ResolutionVote.js");
  db["TableHeader"] = require("./database/models/TableHeader.js");
  db["Tag"] = require("./database/models/Tag.js");
  db["User"] = require("./database/models/User.js");
  db["VotingCategory"] = require("./database/models/VotingCategory.js");

  Vue.db = Vue.prototype.$db = db;
} else import("./registerServiceWorker");

Vue.http = Vue.prototype.$http = axios;
Vue.config.productionTip = false;

Vue.mixin(mixins);
// HACK: needed in many components in meeting
Vue.mixin(mixinsMeeting);
Vue.mixin(mixinsVotes);

Sentry.init({
  Vue,
  dsn: "https://23eda75efcde4c32b394d04b1cf37d3e@o1072067.ingest.sentry.io/6070200",
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ["localhost" /** add others .. */],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  environment: process.env.NODE_ENV,
  logErrors: true,
});

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount("#app");
